<ng-container *ngFor="let item of eventList">
  <btx-list-item [listItem]="item" [region]="region"
  [lang]="lang"></btx-list-item>
</ng-container>
